const deliveryFee = 10.00;
let cartItems = [];
const cartItemsContainer = document.querySelector('.cart-items');
const cartSubtotalElement = document.getElementById('cart-subtotal');
const cartTotalElement = document.getElementById('cart-total');
const widgetCounter = document.getElementById('widget-counter');

function updateCart() {
    cartItemsContainer.innerHTML = '';
    let subtotal = 0;
    let totalItems = 0;

    cartItems.forEach((item, index) => {
        const itemTotal = item.price * item.quantity;
        subtotal += itemTotal;
        totalItems += item.quantity;

        const itemElement = document.createElement('div');
        itemElement.className = 'cart-item';
        itemElement.innerHTML = `
            <p>${item.name} ${item.flavor ? '(' + item.flavor + ')' : ''} (x${item.quantity}) - R$ ${itemTotal.toFixed(2)}
                <button class="remove-btn" onclick="removeItemFromCart(${index})">-</button>
            </p>
        `;
        cartItemsContainer.appendChild(itemElement);
    });

    const total = subtotal + deliveryFee;
    cartSubtotalElement.textContent = subtotal.toFixed(2);
    cartTotalElement.textContent = total.toFixed(2);
    widgetCounter.textContent = totalItems;
}

function changeQuantity(button, delta) {
    const quantityElement = button.parentElement.querySelector('.quantity');
    const itemPriceElement = button.parentElement.querySelector('.item-price');
    const itemPrice = parseFloat(itemPriceElement.getAttribute('data-price'));
    const itemName = button.parentElement.parentElement.querySelector('h3').textContent;

    let currentQuantity = parseInt(quantityElement.textContent);
    let maxQuantity = parseInt(quantityElement.getAttribute('data-max-quantity'));
    let newQuantity = currentQuantity + delta;

    if (newQuantity < 0) {
        newQuantity = 0;
    } else if (newQuantity > maxQuantity) {
        newQuantity = maxQuantity;
    }

    quantityElement.textContent = newQuantity;

    const existingItemIndex = cartItems.findIndex(item => item.name === itemName && !item.flavor);
    if (existingItemIndex > -1) {
        cartItems[existingItemIndex].quantity = newQuantity;
        if (newQuantity === 0) cartItems.splice(existingItemIndex, 1);
    } else if (newQuantity > 0) {
        cartItems.push({ name: itemName, price: itemPrice, quantity: newQuantity, maxQuantity: maxQuantity });
    }

    updateCart();
    animateCartIcon();
}

function addFlavorToCart(itemName, flavor, itemPrice, maxQuantity) {
    const existingItem = cartItems.find(cartItem => cartItem.name === itemName && cartItem.flavor === flavor);
    if (existingItem) {
        if (existingItem.quantity < maxQuantity) {
            existingItem.quantity += 1;
        }
    } else {
        cartItems.push({ name: itemName, flavor: flavor, price: itemPrice, quantity: 1, maxQuantity: maxQuantity });
    }
    updateCart();
    animateCartIcon();
}

function removeItemFromCart(index) {
    if (cartItems[index].quantity > 1) {
        cartItems[index].quantity -= 1;
    } else {
        cartItems.splice(index, 1);
    }
    updateCart();
}

function animateCartIcon() {
    const cartIcon = document.querySelector('.floating-widget');
    cartIcon.classList.add('shake');
    setTimeout(() => {
        cartIcon.classList.remove('shake');
    }, 500);
}

function goToCart() {
    document.getElementById('carrinho').scrollIntoView({ behavior: 'smooth' });
}

function toggleSection(sectionId, imgId) {
    const section = document.getElementById(sectionId);
    const img = document.getElementById(imgId);

    if (section.classList.contains('expanded')) {
        section.classList.remove('expanded');
        img.src = 'https://cdn.shopify.com/s/files/1/0719/1314/4596/files/pngtree-cartoon-glass-of-beer-png-image_6176006.png?v=1716466782';
        img.alt = 'Abrir';
    } else {
        section.classList.add('expanded');
        img.src = 'https://cdn.shopify.com/s/files/1/0719/1314/4596/files/GIRO_pngtree-cartoon-glass-of-beer-png-image_6176006.png?v=1716466774';
        img.alt = 'Fechar';
    }
}
